(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

import React from 'react';
import ImageWebp from './custom/ImageWebp';
import 'blueimp-gallery/css/blueimp-gallery.min.css';

const InteriorGallery = ({
  index,
  normal,
  large
}) => /*#__PURE__*/React.createElement("a", {
  href: large
}, /*#__PURE__*/React.createElement(ImageWebp, {
  src: normal,
  alt: `Gallery #${index}`,
  className: "img-fluid",
  width: "343",
  height: "260"
}));

class ListProjects extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showModal: false
    };
    this.closeModal = this.closeModal.bind(this);
    this.openModal = this.openModal.bind(this);
    this.projectshtml = [];
    this.valuesNormal = Object.keys(this.props.listnormal).map(itm => this.props.listnormal[itm]);
    this.valuesLarge = Object.keys(this.props.listlarge).map(itm => this.props.listlarge[itm]);
    this.finaloop = 0;

    if (this.props.untilto > 0) {
      this.finaloop = this.props.untilto;
    } else {
      this.finaloop = this.valuesNormal.length;
    }

    for (let i = 0; i < this.finaloop; i++) {
      this.projectshtml.push( /*#__PURE__*/React.createElement(InteriorGallery, {
        key: i,
        index: i,
        normal: this.valuesNormal[i],
        large: this.valuesLarge[i]
      }));
    }

    this.goBlueimp = this.goBlueimp.bind(this);
  }

  closeModal() {
    this.setState({
      showModal: false
    });
  }

  openModal(e) {
    this.setState({
      showModal: true
    });
    e.preventDefault();
  }

  componentDidMount() {
    this.goBlueimp();
  }

  goBlueimp() {
    const Gallery = require('blueimp-gallery');

    const clickHandler = function (evt) {
      let event = evt;
      event = event || window.event;
      const target = event.target || event.srcElement,
            link = target.parentNode.parentNode,
            options = {
        index: link,
        event
      },
            links = document.querySelector('#linksgallery').getElementsByTagName('a');
      event.preventDefault();
      Gallery(links, options);
    };

    const links = document.querySelector('#linksgallery').getElementsByTagName('a');

    for (let i = 0; i < links.length; i++) {
      links[i].onclick = clickHandler;
    }
  }

  render() {
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: "listgallery",
      id: "linksgallery"
    }, this.projectshtml), /*#__PURE__*/React.createElement("div", {
      id: "blueimp-gallery",
      className: "blueimp-gallery blueimp-gallery-controls"
    }, /*#__PURE__*/React.createElement("div", {
      className: "slides"
    }), /*#__PURE__*/React.createElement("h3", {
      className: "title"
    }), /*#__PURE__*/React.createElement("a", {
      role: "button",
      className: "prev"
    }, "\u2039"), /*#__PURE__*/React.createElement("a", {
      role: "button",
      className: "next"
    }, "\u203A"), /*#__PURE__*/React.createElement("a", {
      role: "button",
      className: "close"
    }, "\xD7")));
  }

  // @ts-ignore
  __reactstandin__regenerateByEval(key, code) {
    // @ts-ignore
    this[key] = eval(code);
  }

}

const _default = ListProjects;
export default _default;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(InteriorGallery, "InteriorGallery", "/var/www/html/websites/thedistrictusc-com/src/frontend/components/list-gallery-exterior.jsx");
  reactHotLoader.register(ListProjects, "ListProjects", "/var/www/html/websites/thedistrictusc-com/src/frontend/components/list-gallery-exterior.jsx");
  reactHotLoader.register(_default, "default", "/var/www/html/websites/thedistrictusc-com/src/frontend/components/list-gallery-exterior.jsx");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();